import { useContext } from "react";
import { useMutation } from "@tanstack/react-query";
import { useScope } from "@state/scopeContext.lib";
import { uploadDocument } from "@lib/financialDocument";
import { toBase64 } from "@helpers/file";
import { ImporterContext } from "./importer.context";

interface MutationParams {
    file: File;
    documentId: string;
}

export function useImporterUploadMutation(onSuccess: () => void) {
    const { updateDocumentRow, importerQueue, reconciliedFinancialAccount } =
        useContext(ImporterContext);
    const { workspaceId: activeWorkspaceId } = useScope();

    return useMutation({
        mutationFn: async ({ file }: MutationParams) => {
            if (!activeWorkspaceId) {
                throw new Error("No active workspace");
            }

            return await uploadDocument({
                workspaceId: activeWorkspaceId,
                file: await toBase64(file),
                filename: file.name,
                contentType: file.type,
                importerQueue: !reconciliedFinancialAccount
                    ? importerQueue
                    : undefined,
                reconciliedFinancialAccountId: reconciliedFinancialAccount?.id,
            });
        },
        onSuccess: (financialDocument, { documentId }) => {
            updateDocumentRow(documentId, {
                financialDocument,
                integrationAccount:
                    financialDocument.integrationAccount ?? undefined,
            });

            onSuccess();
        },
    });
}
